<template>
  <div>
    <!--设置网址title-->
    <div v-wechat-title="$route.meta.title='理捷管理系统'"></div>
    <!--返回上一页-->
    <div class="backBg">
      <a href="javascript:history.go(-1)">
        <div class="backBox">
          <span class="backIcon"></span>
        </div>
      </a>
      <div class="topTitle">
        <span >日期查询</span>
      </div>
    </div>
    <div class="content_bg">
      <div class="o_blue_box">
        <!--搜索框-->
        <div class="searchBg">
          <div class="weui-search-bar" id="searchBar" ref="searchBar">
            <form class="weui-search-bar__form">
              <div class="weui-search-bar__box">
                <i class="weui-icon-search"></i>
                <input type="search" class="weui-search-bar__input" id="searchInput" ref="sel_date" placeholder="请选择日期~" required readonly @input="checkSearch" @click="selDate"/>
                <a href="javascript:" class="weui-icon-clear" id="searchClear" ref="searchClear" @click="clearSearch"></a>
              </div>
              <label class="weui-search-bar__label" id="searchText" ref="searchText" @click="clickSearch">
                <i class="weui-icon-search"></i>
                <span>{{ thisDate }}</span>
              </label>
            </form>
            <a href="javascript:" class="weui-search-bar__cancel-btn" id="searchSubmit" ref="searchSubmit" @click="search">取消</a>
          </div>
        </div>
        <!--当日总数-->
        <div class="check_list_bg">
          <div class="check_list_box">
            <div class="check_list_w" style="overflow: hidden">
              <!--针车入库总数-->
              <div class="count_box gary_line">
                <p>针车入库总数</p>
                <p>{{ count_data.part1_in_num }}件</p>
              </div>
              <!--针车出库总数-->
              <div class="count_box gary_line">
                <p>针车出库总数</p>
                <p>{{ count_data.part1_out_num }}件</p>
              </div>
              <!--针车不良总数-->
              <div class="count_box">
                <p>针车不良总数</p>
                <p>{{ count_data.part1_wrong_num }}件</p>
              </div>
              <!--成型入库总数-->
              <div class="count_box gary_line">
                <p>成型入库总数</p>
                <p>{{ count_data.part2_in_num }}件</p>
              </div>
              <!--成型出库总数-->
              <div class="count_box gary_line">
                <p>成型出库总数</p>
                <p>{{ count_data.part2_out_num }}件</p>
              </div>
              <!--成型不良总数-->
              <div class="count_box">
                <p>成型不良总数</p>
                <p>{{ count_data.part2_wrong_num }}件</p>
              </div>
              <!--成品入库总数-->
              <div class="count_box gary_line">
                <p>成品入库总数</p>
                <p>{{ count_data.part3_in_num }}件</p>
              </div>
              <!--装配不良总数-->
              <div class="count_box gary_line">
                <p>装配不良总数</p>
                <p>{{ count_data.part3_wrong_num }}件</p>
              </div>
            </div>
          </div>
        </div>
        <!--列表-->
        <div class="check_list_bg" style="padding-top: 0">
          <div class="check_list_box" v-for="item,index in list">
            <div class="check_list_w">
              <div class="d_f_box">
                <div class="d_f_1">
                  <p>制造单号：{{ item.order_no }}</p>
                </div>
                <p class="order_date">{{ thisDate }}</p>
              </div>
              <div class="d_f_box" @click="getCodeDetail(1,item.part1_in_num,item.order_id)">
                <div class="d_f_1">
                  <p class="color_4598FF">针车中仓入库数</p>
                </div>
                <p :class="item.part1_in_num > 0 ? 'data_icon':''">{{ item.part1_in_num }}件</p>
              </div>
              <div class="d_f_box" @click="getCodeDetail(2,item.part1_out_num,item.order_id)">
                <div class="d_f_1">
                  <p class="color_4598FF">针车中仓出库数</p>
                </div>
                <p :class="item.part1_out_num > 0 ? 'data_icon':''">{{ item.part1_out_num }}件</p>
              </div>
              <div class="d_f_box" @click="getCodeDetail(6,item.part1_wrong_num,item.order_id)">
                <div class="d_f_1">
                  <p class="color_4598FF">针车不良数</p>
                </div>
                <p :class="item.part1_wrong_num > 0 ? 'data_icon color_f24242':''">{{ item.part1_wrong_num }}件</p>
              </div>
              <div class="get_more_bg" ref="get_more_bg" style="display: none">
                <div class="d_f_box" @click="getCodeDetail(3,item.part2_in_num,item.order_id)">
                  <div class="d_f_1">
                    <p class="color_4598FF">成型中仓入库数</p>
                  </div>
                  <p :class="item.part2_in_num > 0 ? 'data_icon':''">{{ item.part2_in_num }}件</p>
                </div>
                <div class="d_f_box" @click="getCodeDetail(3,item.part2_out_num,item.order_id)">
                  <div class="d_f_1">
                    <p class="color_4598FF">成型中仓出库数</p>
                  </div>
                  <p :class="item.part2_out_num > 0 ? 'data_icon':''">{{ item.part2_out_num }}件</p>
                </div>
                <div class="d_f_box" @click="getCodeDetail(3,item.part3_in_num,item.order_id)">
                  <div class="d_f_1">
                    <p class="color_4598FF">成品入库数</p>
                  </div>
                  <p :class="item.part3_in_num > 0 ? 'data_icon':''">{{ item.part3_in_num }}件</p>
                </div>
                <div class="d_f_box" @click="getCodeDetail(3,item.part2_wrong_num,item.order_id)">
                  <div class="d_f_1">
                    <p class="color_4598FF">成型不良品数</p>
                  </div>
                  <p :class="item.part2_wrong_num > 0 ? 'data_icon color_f24242':''">{{ item.part2_wrong_num }}件</p>
                </div>
                <div class="d_f_box" @click="getCodeDetail(3,item.part3_wrong_num,item.order_id)">
                  <div class="d_f_1">
                    <p class="color_4598FF">装配不良数</p>
                  </div>
                  <p :class="item.part3_wrong_num > 0 ? 'data_icon color_f24242':''">{{ item.part3_wrong_num }}件</p>
                </div>
              </div>
              <div class="get_more_box">
                <span class="get_more_btn get_more_arr" ref="get_more" @click="getMore(index)">查看更多</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { webToast } from "@/assets/js/alertPopShow";
  import loading from '@/components/loading'
  export default {
    name:'orderCheck',
    components:{
      loading,
    },
    data(){
      return{
        list:'',
        count_data:'',
        thisDate:'',
        loading:false,
      }
    },
    created:function () {
      var that = this;
      var token = localStorage.getItem('token');
      var formData = new FormData();
//      获取当前年月日
      var date = new Date();
      var thisDate = date.getFullYear() + '-' + (Number(date.getMonth()) + 1) + '-' + date.getDate();
      that.thisDate = thisDate;
      formData.append('token',token);
      formData.append('date',thisDate);
      that.loading = true;
      that.app.postData('/mhome.php/Count/searchOrderByDate',formData
        ,result =>{
          if( result.status == 503 ){
            webToast('暂无数据','middle',1500);
          }else {
            that.list = result.content.order_list;
            that.count_data = result.content.count_data;
          }
        })
      //    配置微信jssdk
      var url = window.location.href.split('#')[0];
      that.app.wxjssdk(url);
    },
    methods:{
//      点击搜索框
      clickSearch(){
        this.$refs.searchBar.classList.add('weui-search-bar_focusing');
        this.selDate();
      },
//      选择日期
      selDate(){
        var sel_date = this.$refs.sel_date;
        var searchSubmit = this.$refs.searchSubmit;
        var searchClear = this.$refs.searchClear;
        weui.datePicker({
          start: 1990,
          end: new Date().getFullYear(),
          onChange:function (result) {

          },
          onConfirm: function (result) {
            sel_date.value = result[0] + '-' + result[1] + '-' + result[2];
            searchSubmit.innerHTML = '搜索';
            searchClear.style.display = 'block';
          },
        })
      },
//      取消搜索
      cancelSearch(){
        this.$refs.searchBar.classList.remove('weui-search-bar_focusing');
        this.$refs.sel_date.blur();
      },
//      清除搜索内容
      clearSearch(){
//        this.$refs.sel_date.focus();
        this.$refs.sel_date.value = '';
        this.$refs.searchClear.style.display = 'none';
        this.$refs.searchSubmit.innerHTML = '取消';
      },
//      搜索框失去焦点
      blurSearch(){
        if(!this.$refs.sel_date.value.length){
          this.cancelSearch();
          this.$refs.searchSubmit.innerHTML = '取消';
        }
      },
//      监听搜索
      checkSearch(){
        if(this.$refs.sel_date.value.length){
          this.$refs.searchSubmit.innerHTML = '搜索';
        }
      },
//      点击搜索
      search(){
        if(this.$refs.sel_date.value.length){
          var that = this;
          var token = localStorage.getItem('token');
          var formData = new FormData();
//      获取当前年月日
          var thisDate = that.$refs.sel_date.value;
          that.thisDate = thisDate;
          formData.append('token',token);
          formData.append('date',thisDate);
          that.loading = true;
          that.app.postData('/mhome.php/Count/searchOrderByDate',formData
            ,result =>{
              if( result.status == 503 ){
                webToast('暂无数据','middle',1500);
              }else {
                that.list = result.content.order_list;
                that.count_data = result.content.count_data;
                that.thisDate = thisDate;
              }
            })
        }else{
          this.cancelSearch();
        }
      },
      //      查看编码详情
      getCodeDetail(type,num,order_id){
        var that = this;
        var token = localStorage.getItem('token');
        var date = that.thisDate;
        var formData = new FormData();
        formData.append('token',token);
        formData.append('order_id',order_id);
        formData.append('type',type);
        if( num > 0 ){
          that.$router.push({ name:'codeDetail',query:{ order_id:order_id,type:type,date:date } });
          return false;
        }else{
          webToast('暂无数据','middle',1500);
        }
      },
//      展开列表
      getMore(index){
        var get_more = this.$refs.get_more[index];
        var get_more_bg = this.$refs.get_more_bg[index];
        if(get_more.classList[1] == 'get_more_arr'){
          get_more.classList.remove('get_more_arr');
          get_more.classList.add('get_more_arr2');
          get_more.innerHTML = '收起';
          get_more_bg.style.display = 'block';
        }else{
          get_more.classList.remove('get_more_arr2');
          get_more.classList.add('get_more_arr');
          get_more.innerHTML = '查看更多';
          get_more_bg.style.display = 'none';
        }
      }
    },
    beforeRouteEnter(to,from,next){
      window.document.body.style.background = '#F4F4F4';
      if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
        if (to.path !== location.pathname) {
          // 此处不可使用location.replace
          location.assign(to.fullPath)
        } else {
          next()
        }
      }else{
        next();
      }
    },
    beforeRouteLeave(to,from,next){
//      window.document.body.style.background = '';
      next();
    }
  }
</script>

<style scoped>
  body{
    background: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/dateCheck.vue